import config from '../config'
import http from '../http'

export default{
	getNewRulesIntegral:async function(payload) {
		const res = await http({
			url: config.GET_NOWRULES_INTEGRAL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	refreshIntegral:async function(payload) {
		const res = await http({
			url: config.REFRESH_INTEGRAL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	mandatorBind:async function(payload) {
		const res = await http({
			url: config.BAND_SELLERID_AND_SHORID,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取仓库帐号绑定的所有卖家帐号
	getStroeSeller:async function(payload) {
		const res = await http({
			url: config.GET_STOTRE_SELLER,
			method: 'get',
			data: payload
		})
		return res.data
	},
	//仓库帐号获取收入，支出明细
	getIntegralLog:async function(payload) {
		const res = await http({
			url: config.GET_INTEGRA_LOG,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取占用积分明细
	getExceptIntegralLog:async function(payload) {
		const res = await http({
			url: config.GET_EXCEPT_INTEGRAL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//查找预扣订单号
	getDeductionOrder:async function(payload) {
		const res = await http({
			url: config.GET_ORDER_DEDUCTION,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取充值规则
	getUserRechargeRule:async function(payload) {
		const res=await http({
			url:config.GET_PAY_OPTIONS,
			method:'post',
			data:{
				...payload
			}
		})

		return res.data
	}
}
